import { Dialog } from "primereact/dialog"
import "./QuestionsNotAvailableDialog.scss"

export const QuestionsNotAvailableDialog = ({ questionsNotAvailbleDialog, endTestHandlerWithoutResult }: any) => {
  return (
    <>      <Dialog header={null} position="top" className="custom-expire-dialog" visible={questionsNotAvailbleDialog}  onHide={() => endTestHandlerWithoutResult()} closeOnEscape={false} >
      <div className="Expire-time-box text-center">
        <div className="ex-t-head">Questions Are not Available.</div>
        <div className="mb-3">Please try later.</div>
        <div className="mb-2">
          <button className="ia-btn ia-btn-primary"
            onClick={() => endTestHandlerWithoutResult()} >End Test</button>
        </div>
      </div>
    </Dialog>
    </>
  )
}